import React from 'react';
import { Check } from 'lucide-react';
interface Plan {
  name: string;
  fee: string;
  minInvestment: string;
  return: string;
  risk: 'Low' | 'Medium' | 'High';
  recommended?: boolean;
}
const plans: Plan[] = [{
  name: 'Conservative',
  fee: '0.25%',
  minInvestment: '$500',
  return: '4-6%',
  risk: 'Low'
}, {
  name: 'Balanced',
  fee: '0.50%',
  minInvestment: '$2,500',
  return: '7-9%',
  risk: 'Medium',
  recommended: true
}, {
  name: 'Aggressive',
  fee: '0.85%',
  minInvestment: '$10,000',
  return: '10-12%',
  risk: 'High'
}];
export function ComparisonTable() {
  return <div className="w-full overflow-x-auto" data-id="element-105">
      <table className="w-full min-w-[800px] border-collapse text-left" data-id="element-106">
        <thead data-id="element-107">
          <tr data-id="element-108">
            <th className="w-[30%] py-6 px-4 border-b border-black text-xs uppercase tracking-widest font-bold" data-id="element-109">
              Plan Details
            </th>
            {plans.map(plan => <th key={plan.name} className={`w-[23%] py-6 px-4 border-b border-black align-bottom ${plan.recommended ? 'bg-red-50/30' : ''}`} data-id="element-110">
                <div className="flex flex-col gap-2" data-id="element-111">
                  {plan.recommended && <span className="text-[10px] uppercase tracking-widest text-[var(--color-swiss-red)] font-bold" data-id="element-112">
                      Recommended
                    </span>}
                  <span className="text-xl font-bold" data-id="element-113">{plan.name}</span>
                </div>
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-114">
          <tr data-id="element-115">
            <td className="py-6 px-4 border-b border-[var(--color-swiss-gray)] font-medium" data-id="element-116">
              Annual Management Fee
            </td>
            {plans.map(plan => <td key={`${plan.name}-fee`} className={`py-6 px-4 border-b border-[var(--color-swiss-gray)] ${plan.recommended ? 'bg-red-50/30' : ''}`} data-id="element-117">
                {plan.fee}
              </td>)}
          </tr>
          <tr data-id="element-118">
            <td className="py-6 px-4 border-b border-[var(--color-swiss-gray)] font-medium" data-id="element-119">
              Minimum Investment
            </td>
            {plans.map(plan => <td key={`${plan.name}-min`} className={`py-6 px-4 border-b border-[var(--color-swiss-gray)] ${plan.recommended ? 'bg-red-50/30' : ''}`} data-id="element-120">
                {plan.minInvestment}
              </td>)}
          </tr>
          <tr data-id="element-121">
            <td className="py-6 px-4 border-b border-[var(--color-swiss-gray)] font-medium" data-id="element-122">
              Expected Annual Return
            </td>
            {plans.map(plan => <td key={`${plan.name}-return`} className={`py-6 px-4 border-b border-[var(--color-swiss-gray)] ${plan.recommended ? 'bg-red-50/30' : ''}`} data-id="element-123">
                {plan.return}
              </td>)}
          </tr>
          <tr data-id="element-124">
            <td className="py-6 px-4 border-b border-[var(--color-swiss-gray)] font-medium" data-id="element-125">
              Risk Profile
            </td>
            {plans.map(plan => <td key={`${plan.name}-risk`} className={`py-6 px-4 border-b border-[var(--color-swiss-gray)] ${plan.recommended ? 'bg-red-50/30' : ''}`} data-id="element-126">
                <span className={`inline-block px-2 py-1 text-xs font-bold uppercase tracking-wider border ${plan.risk === 'Low' ? 'border-green-600 text-green-700' : plan.risk === 'Medium' ? 'border-yellow-600 text-yellow-700' : 'border-red-600 text-red-700'}`} data-id="element-127">
                  {plan.risk}
                </span>
              </td>)}
          </tr>
          <tr data-id="element-128">
            <td className="py-8 px-4" data-id="element-129"></td>
            {plans.map(plan => <td key={`${plan.name}-cta`} className={`py-8 px-4 ${plan.recommended ? 'bg-red-50/30' : ''}`} data-id="element-130">
                <button className={`w-full py-3 px-4 text-sm font-bold uppercase tracking-wider transition-colors ${plan.recommended ? 'bg-[var(--color-swiss-red)] text-white hover:bg-[var(--color-swiss-red-dark)]' : 'bg-black text-white hover:bg-gray-800'}`} data-id="element-131">
                  Select
                </button>
              </td>)}
          </tr>
        </tbody>
      </table>
    </div>;
}